var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEntry = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16669 5.83333L8.00002 7L10.1667 9.16667H1.66669V10.8333H10.1667L8.00002 13L9.16669 14.1667L13.3334 10L9.16669 5.83333ZM16.6667 15.8333H10V17.5H18.3334V2.5H10V4.16667H16.6667V15.8333Z",
    fill: "#6D6F71"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEntry, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Entry.29a65854.svg";
export { ForwardRef as ReactComponent };